import * as React from "react";

import Typography from "@mui/material/Typography";

interface SectionHeaderProps {
    title: string;
}

export default function SectionHeader({
    title,
}: SectionHeaderProps): React.JSX.Element {
    return (
        <Typography
            variant="h6"
            sx={{
                color: "white",
                fontWeight: 700,
                fontSize: "1.1rem",
                marginBottom: "5px",
                marginTop: "10px",
            }}
        >
            {title}
        </Typography>
    );
}
